import '../static/Col.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
const col = `_col_06fa8bd`;
const col1 = `_col1_a40f09e`;
const col2 = `_col2_624e2db`;
const col3 = `_col3_363234a`;
const col4 = `_col4_b51364d`;
const col5 = `_col5_cf34e9d`;
const col6 = `_col6_87fdda4`;
const col7 = `_col7_77e1f0c`;
const col8 = `_col8_408a573`;
const col9 = `_col9_3c70361`;
const col10 = `_col10_644bea6`;
const col11 = `_col11_fc39e57`;
const col12 = `_col12_bb71a1b`;
const colMd1 = `_colMd1_9cba5b9`;
const colMd2 = `_colMd2_57d5c42`;
const colMd3 = `_colMd3_f367feb`;
const colMd4 = `_colMd4_d85aeea`;
const colMd5 = `_colMd5_7bc3ced`;
const colMd6 = `_colMd6_9a33a5c`;
const colMd7 = `_colMd7_62d6be7`;
const colMd8 = `_colMd8_edceff3`;
const colMd9 = `_colMd9_fe2492c`;
const colMd10 = `_colMd10_dd1d516`;
const colMd11 = `_colMd11_6f1d83a`;
const colMd12 = `_colMd12_3551a4d`;
const colSm1 = `_colSm1_77cb7ab`;
const colSm2 = `_colSm2_eb56335`;
const colSm3 = `_colSm3_374344c`;
const colSm4 = `_colSm4_0721988`;
const colSm5 = `_colSm5_6b02050`;
const colSm6 = `_colSm6_a7ce515`;
const colSm7 = `_colSm7_4dcb55d`;
const colSm8 = `_colSm8_60e9350`;
const colSm9 = `_colSm9_e8cb0ce`;
const colSm10 = `_colSm10_64614ce`;
const colSm11 = `_colSm11_d6bd054`;
const colSm12 = `_colSm12_d70ee50`;
const styles = { col, col1, col2, col3, col4, col5, col6, col7, col8, col9, col10, col11, col12, colMd1, colMd2, colMd3, colMd4, colMd5, colMd6, colMd7, colMd8, colMd9, colMd10, colMd11, colMd12, colSm1, colSm2, colSm3, colSm4, colSm5, colSm6, colSm7, colSm8, colSm9, colSm10, colSm11, colSm12 };
const Col = forwardRef(
  ({ as, className, lg = 1, md = 1, sm = 4, ...props }, ref) => {
    const Component = useTagName(as);
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        ...props,
        "data-ui-col": true,
        ref,
        className: clsx(
          styles.col,
          {
            [styles[`colSm${Math.max(1, sm)}`]]: sm,
            [styles[`colMd${Math.max(1, md)}`]]: md
          },
          styles[`col${Math.max(1, lg)}`],
          className
        )
      }
    );
  }
);
export {
  Col as C
};
//# sourceMappingURL=Col.COJSUXXS.mjs.map
